import { render, staticRenderFns } from "./FormFeedsNotes.vue?vue&type=template&id=24b47b16&"
import script from "./FormFeedsNotes.vue?vue&type=script&lang=js&"
export * from "./FormFeedsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports